export const OPERAND = "operand";
export const OPERATOR = "operator";
